const env = {
    env: process.env.REACT_APP_ENV,
    app: {
        port: 3000
    },
    urls: {
      incident_gql_url: process.env.REACT_APP_INC_GQL_URL,
      asset_employee_gql_url: process.env.REACT_APP_AE_GQL_URL
    }
};

module.exports = env;